import PlaylistApi from "@/api/playlist/PlaylistApi";
// import router from '@/router';

const state = {
  selectedGroupId: 'all',
  // selectedGroupName: '플레이리스트 > All Groups',
  // selectedGroupName: null,
  selectedGroupName: 'All Groups',
  currentPage: 1,
  selectedItems: [],
  selectedGroup: [],
  groupingCompleted: false,
  deleteStatus: false,
  modifyStatus: false,
};

const mutations = {
  setSelectedGroupId(state, groupId) {
    state.selectedGroupId = groupId;
  },

//   setEndIndex(state, endIndex) {
//     state.endIndex = endIndex;
//     if(state.total != 0 && state.endIndex >= state.total){
//         state.endIndex = state.total
//     }
// },
  setSelectedGroupName(state, groupName) {
    state.selectedGroupName = groupName;
  },
  setCurrentPage(state, page) {
    state.currentPage = page;
  },
  setSelectedItems(state, items) {
    state.selectedItems = items;
  },
  UPDATE_SELECTED_ITEMS(state, items) {
    state.selectedItems = items;
  },
  UPDATE_SELECTED_GROUP(state, group) {
    state.selectedGroup = group;
  },
  SET_GROUPING_COMPLETED(state, value) {
    state.groupingCompleted = value;
    console.log('SET_GROUPING_COMPLETED', state.groupingCompleted);
  },
  INVALIDATE_CACHE(state) {
    state.cachedPlaylists = {};
  },
  setDeleteStatus(state, status) {
    state.deleteStatus = status;
  },
  setModifyStatus(state, status) {
    state.modifyStatus = status;
  }
};

const actions = {
  // updateSelectedGroupId({ commit, dispatch, rootGetters }, groupId) {
  //   commit('setSelectedGroupId', groupId);
  //   const t = rootGetters['t']; 
  //   const groupName = groupId === 'all' ? t('All Groups') : '';
  //   if( groupName === 'all'){
  //     dispatch('reportDeleteStatus', true);
  //   }
  // },
  updateSelectedGroupId({ commit, dispatch }, groupId) {
    commit('setSelectedGroupId', groupId);
    const groupName = groupId === 'all' ? 'All Groups' : '';
    if( groupName === 'all'){
      dispatch('reportDeleteStatus', true);
    }
  },
  reportDeleteStatus({ commit }, status) {
    commit('setDeleteStatus', status);
  },
  // updateSelectedGroupName({ commit, rootGetters }, groupName) {
  //   const t = rootGetters['t'];
  //   const tmp = groupName == 'All Groups' ? t('All Groups') : groupName;
  //   commit('setSelectedGroupName', tmp);
  // },
  updateSelectedGroupName({ commit }, groupName) {
    const tmp = groupName == 'All Groups' ? 'All Groups' : groupName;
    commit('setSelectedGroupName', tmp);
  },
  updateCurrentPage({ commit }, page) {
    commit('setCurrentPage', page);
  },
  updateSelectedItems({ commit }, items) {
    commit('setSelectedItems', items);
  },
  reportModifyStatus({ commit }, status) {
    commit('setModifyStatus', status);
  },

  //그룹핑 -> 컴포넌트로 전달
  async grouping({ commit, state }, { assetIds, playlistIds }) {
    try {
      const response = await PlaylistApi.groupingAsset({ assetIds, playlistIds });
      if (response.status === '1') {
        commit('SET_GROUPING_COMPLETED', true);
        commit('UPDATE_SELECTED_ITEMS', []);
        commit('UPDATE_SELECTED_GROUP', []);
        commit('INVALIDATE_CACHE');
        setTimeout(() => {
          commit('SET_GROUPING_COMPLETED', false);
        }, 1000);
      }
    } catch (error) {
      console.error('error', error);
    }
  },
  //그룹에 노래넣기
  async addPlaylistToGroup({ commit, state }, { assetIds, groupId }) {
    try {
      const response = await PlaylistApi.addPlaylist({ assetIds, groupId });
      if (response.status === '1') {
        //console.log('성공');
        commit('SET_GROUPING_COMPLETED', true);
        //commit('setSelectedGroupId', groupId); 
        setTimeout(() => {
          commit('SET_GROUPING_COMPLETED', false);
        }, 1000);
      }
    } catch (error) {
      console.error('error', error);
    }
  },
  async updateGroupId({commit}, data){
      commit('setSelectedGroupId', data);
  },

};

const getters = {
  selectedItems: state => state.selectedItems,
};



export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
